// Public re-exports of the otherwise-private `_section.*` leaf components, so
// sibling tiles (e.g. the deck card tile) can compose the glyph and gloss
// without reaching across the `_section.*` encapsulation boundary themselves.
export { MorphemeDetailsTileGlossSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.details._section.gloss";
export { MorphemeDetailsTileGlyph } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.tile.ui.details._section.morpheme";
